import React from "react"

function Annotation(props){
return(
        <div className="annotatebox">
            <p className="annotatedate legend">{props.date}</p>
            <img className="annotateicon" alt="Al Jazeera" width="50px" height="auto" src={props.annotateicon}/>
            <p className="annotatecomment legend">{props.comment}</p>
            {/* <img alt="YemenCalendar" width="100px" height="auto" src={props.annotateimage}/> */}
        </div>
)
}

export default Annotation